<template>
  <div class="edit-bank-box">
    <el-dialog
      title="退款操作"
      :visible.sync="dialogVisible"
      width="640px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item prop="bankCode" style="font-size:20px;">
          <div>
            <span style="font-size:18px;color:red;position:absolute;left:-60px;top:0">警告:</span>
            <span>{{'请向提现平台确认订单ID '}}</span>
            <span style="color:green">{{ form.id}}</span>
            <span>{{' 是否可以退款？以避免重复退款。'}}</span>
          </div>
          <div>
            <span>{{'点击【继续】，提现金额 '}}</span>
            <span style="color:red">{{form.payMoney}}</span>
            <span>{{' 元将原路退返'}}</span>
            <span>{{text=this.form.withdrawType===2?'商区 ':'用户 '}}</span>
            <span style="color:green" v-if="this.form.withdrawType!==2">{{form.uid}}</span>
            <span style="color:green" v-if="this.form.withdrawType===2">{{form.districtCode}}</span>
          </div>
        </el-form-item>

        <el-form-item label="备注:" prop="remark">
          <el-input v-model="form.remark" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">继 续</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      form: {
        id: "",
        remark: "",
        payMoney: "",
        uid: "",
        withdrawType: "",
        districtCode: ""
      },
      // 表单验证规则
      rules: {}
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.Refund();
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
        }
      });
    },
    //退款
    Refund() {
      this.$confirm("您确定要进行当前退款操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.Refund({ id: this.form.id, remark: this.form.remark }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: "退款成功",
              type: "success"
            });
            this.$parent.getRefundList();
            this.dialogVisible = false;
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("退款失败！");
            }
            this.flag = false;
          }
        });
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        payMoney: "",
        uid: "",
        withdrawType: "",
        districtCode: ""
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.form.id = data.id;
      this.form.payMoney = data.payMoney / 100;
      this.form.uid = data.uid;
      this.form.withdrawType = data.withdrawType;
      this.form.districtCode = data.districtCode;
    }
  }
};
</script>
<style lang="scss" >
</style>
